// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FormasPagamentoFranquia_RemoverResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/formas_pagamento_franquias/remover
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface FormasPagamentoFranquia_RemoverResponseDados {
forma_pagamento_id?: number
franquia_id?: number
}

export type FormasPagamentoFranquia_RemoverResponse = ApiResponse<FormasPagamentoFranquia_RemoverResponseDados>;

registerResponseContract('FormasPagamentoFranquia_RemoverResponse', {
  forma_pagamento_id: { type: 'number',  required: false },
  franquia_id:        { type: 'number',  required: false },
})
